import script from "./ConventionView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConventionView.vue?vue&type=script&setup=true&lang=js"

import "./ConventionView.vue?vue&type=style&index=0&id=df632fec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df632fec"]])

export default __exports__